import { render, staticRenderFns } from "./ProvinceReportPage.vue?vue&type=template&id=643df137&scoped=true"
import script from "./ProvinceReportPage.vue?vue&type=script&lang=js"
export * from "./ProvinceReportPage.vue?vue&type=script&lang=js"
import style0 from "./ProvinceReportPage.vue?vue&type=style&index=0&id=643df137&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643df137",
  null
  
)

export default component.exports